// extracted by mini-css-extract-plugin
var _1 = "ChatTableRowTitle-moduleemptyChatTitle__oNxX9";
var _2 = "ChatTableRowTitle-moduletitleText__cZd5o TableCellText-moduleTableCellText__b5epO";
export { _1 as "emptyChatTitle", _2 as "titleText" }
